<template>
  <div class="linked-user-container" v-if="null !== user">
    <div>
      {{ user.firstName }} {{ user.lastName }} -
      <small>{{ user.email }} ({{ relationship }})</small>
    </div>
    <b-button
      variant="primary"
      size="sm"
      class="red lu-action-item"
      :disabled="state.isBusy"
      @click="emitUp(events.messageUser)"
      ><b-icon-envelope-fill
        class="linked-user-button-icon"
      ></b-icon-envelope-fill>
      send message</b-button
    ><b-button
      variant="primary"
      size="sm"
      class="red lu-action-item"
      :disabled="state.isBusy"
      @click="emitUp(events.viewProfile)"
    >
      <b-icon-person-fill class="linked-user-button-icon"></b-icon-person-fill>
      {{ readonly ? "view profile" : "edit user" }} </b-button
    ><b-button
      v-if="!readonly"
      variant="primary"
      size="sm"
      class="red lu-action-item"
      :disabled="state.isBusy"
      @click="emitUp(events.removeUser)"
      ><b-icon-x class="linked-user-button-icon"></b-icon-x> remove</b-button
    >
  </div>
</template>

<script>
export const ViewProfileEvent = "view-profile";
export const MessageUserEvent = "message-user";
export const RemoveUserEvent = "remove-linked-user";
import { EmitUp } from "../lib/VueHelpers";
import {
  BButton,
  BIconEnvelopeFill,
  BIconPersonFill,
  BIconX
} from "bootstrap-vue";
export default {
  name: "LinkedUser",
  components: { BButton, BIconEnvelopeFill, BIconPersonFill, BIconX },
  data() {
    return {
      state: {
        isBusy: false
      },
      events: {
        viewProfile: ViewProfileEvent,
        messageUser: MessageUserEvent,
        removeUser: RemoveUserEvent
      }
    };
  },
  methods: {
    emitUp(name) {
      // this will emit events on every parent object as well -- allows us to proceed a little further before
      // adding in an event bus or vuex
      let that = this;
      this.state.isBusy = true;
      let payload = {
        user: this.user,
        relationship: this.relationship,
        handledCallback: () => (that.state.isBusy = false)
      };
      EmitUp(name, payload, this);
    }
  },
  props: {
    user: Object,
    relationship: String,
    readonly: { type: Boolean, default: false }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.linked-user-container {
  margin: 1rem 0;
}
.lu-action-item {
  margin-right: 0.5rem;
}
</style>
